import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { enhanceWithCollapsible } from "../../components/Collapsible/Collapsible";
import styles from "./VerticalPromotionList.scss";
import PromotionItem from "./PromotionItem";
import classnames from "classnames";
import { CarouselNextIcon, CarouselPrevIcon } from "../../theme/assets";

const scrollStep = 100;

class VerticalPromotionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableScrollUp: true,
      disableScrollDown: true,
      enableControls: false,
    };
    this.scrollHandler = this.scrollHandler.bind(this);
    this.changeRemoved = this.changeRemoved.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
  }

  componentDidMount() {
    if (this.scrollableContainer) {
      this.scrollableContainer.addEventListener("scroll", this.scrollHandler);
      /* Because container height is not set at component did mount we must use a timer
       *  this could potentially be fixed by not rendering the component UNTIL the height
       *  has been set in RoomSelection. */
      setTimeout(() => {
        if (
          this.scrollableContainer &&
          this.scrollableContainer.offsetHeight !== this.scrollableContainer.scrollHeight
        ) {
          this.setState({ disableScrollDown: false, enableControls: true });
        }
      }, 5000);
    }
  }
  componentWillUnmount() {
    if (this.scrollableContainer) {
      this.scrollableContainer.removeEventListener("scroll", this.scrollHandler);
    }
  }

  changeRemoved() {
    this.removed = false;
  }

  scrollHandler() {
    if (this.scrollableContainer && !this.removed) {
      this.scrollableContainer.click();
      this.removed = true;
    }
  }

  scrollDown() {
    if (this.scrollableContainer) {
      const scrollPosition =
        this.scrollableContainer.offsetHeight + this.scrollableContainer.scrollTop;
      if (scrollPosition + scrollStep / 2 >= this.scrollableContainer.scrollHeight) {
        if (!this.state.disableScrollDown) {
          this.setState({ disableScrollDown: true });
        }
      } else {
        if (this.state.disableScrollUp) {
          this.setState({ disableScrollUp: false });
        }
        this.scrollableContainer.scrollTop += scrollStep;
      }
    }
  }

  scrollUp() {
    if (this.scrollableContainer) {
      if (this.scrollableContainer.scrollTop <= 0) {
        if (!this.state.disableScrollUp) {
          this.setState({ disableScrollUp: true });
        }
      } else {
        if (this.state.disableScrollDown) {
          this.setState({ disableScrollDown: false });
        }
        this.scrollableContainer.scrollTop -= scrollStep;
      }
    }
  }

  render() {
    const {
      fullWidth,
      promotions,
      mode,
      currency,
      summaryCart,
      inverseTextColor,
      textColor,
    } = this.props;

    const { enableControls } = this.state;

    if ((mode === "fullWidth" && !fullWidth) || (mode !== "fullWidth" && fullWidth)) {
      return null;
    }

    const mainContainerClassNames = classnames([
      "wbkv9-VerticalPromotionList",
      styles.verticalPromotionList,
      {},
    ]);
    const position = () => this.domElem && this.domElem.getBoundingClientRect();
    const toolTipOffset = () => (position() && position().top + 15) || 0;
    const toolTipVerticalLimit = () => (position() && position().bottom) || 0;
    const scrollTop = () => this.scrollableContainer.scrollTop;

    return (
      <div
        className={mainContainerClassNames}
        ref={elem => {
          this.domElem = elem;
        }}>
        <div className={styles.scrollableContainerWrapper}>
          <div
            className={styles.scrollableContainer}
            ref={elem => {
              this.scrollableContainer = elem;
            }}>
            {summaryCart}

            {this.props.showPromos &&
              promotions &&
              promotions.map((promotion, idx) => (
                <PromotionItem
                  toolTipOffset={toolTipOffset}
                  toolTipVerticalLimit={toolTipVerticalLimit}
                  id={idx}
                  key={idx}
                  promotion={promotion}
                  scrollTop={scrollTop}
                  changeRemoved={this.changeRemoved}
                  currency={currency}
                  inverseTextColor={inverseTextColor}
                  textColor={textColor}
                />
              ))}
          </div>
        </div>

        {enableControls && (
          <div className={styles.controls}>
            <button
              className={classnames(
                styles.scrollerControl,
                this.state.disableScrollDown && styles.inactive
              )}
              onClick={this.scrollDown}>
              <CarouselNextIcon />
            </button>
            <button
              className={classnames(
                styles.scrollerControl,
                this.state.disableScrollUp && styles.inactive
              )}
              onClick={this.scrollUp}>
              <CarouselPrevIcon />
            </button>
          </div>
        )}
      </div>
    );
  }
}

VerticalPromotionList.propTypes = {
  promotions: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool.isRequired,
  showPromos: PropTypes.bool.isRequired,
  propertyTicker: PropTypes.string,
  mode: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  summaryCart: PropTypes.object,
  inverseTextColor: PropTypes.string,
  textColor: PropTypes.string,
};

export default enhanceWithCollapsible(injectIntl(VerticalPromotionList));
